
import {
    EDIT_VERSION_LOADING,
    EDIT_VERSION_LOADED,
    EDIT_VERSION_ERROR,
    EDIT_VERSION_RESET,
    
    GET_VERSION_LOADING,
    GET_VERSION_LOADED,
    GET_VERSION_ERROR
  } from './../../types/versiontypes';

const INITIAL_STATE = {
    versionedit: [],
    versionData: [],
    isData:false,
    isVerEdited: false,
    isVerEditedLoading: false,
    isVerLoading: false,
    error: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case GET_VERSION_LOADING:
            return {
                ... state,
                isVerLoading : true,
                isData:false,
                error: ''
            }
        case GET_VERSION_LOADED:
            return {
                ...state,
                isVerLoading : false,
                versionData: action.payload,
                isData:true,
                error: ''
            };
        case GET_VERSION_ERROR:
            return {
                ... state,
                isVerLoading : false,
                isData:false,
                error: action.payload 
            }

        case EDIT_VERSION_LOADING:
            return {
                ... state,
                isVerEditedLoading : true,
                isVerEdited: false,
                error: ''
            }
        case EDIT_VERSION_LOADED:
            return {
                ...state,
                isVerEditedLoading : false,
                isVerEdited: true,
                versionedit: action.payload,
                error: ''
            };
        case EDIT_VERSION_ERROR:
            return {
                ... state,
                isVerEditedLoading : false,
                isVerEdited: false,
                error: action.payload
            }
        case EDIT_VERSION_RESET:
            return {
                ...state,
                isVerEdited: false,
            };

        default: return state;
    }
}